import { render, staticRenderFns } from "./LightingHistory.vue?vue&type=template&id=0bbef39c&scoped=true"
import script from "./LightingHistory.vue?vue&type=script&lang=js"
export * from "./LightingHistory.vue?vue&type=script&lang=js"
import style0 from "./LightingHistory.vue?vue&type=style&index=0&id=0bbef39c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbef39c",
  null
  
)

export default component.exports